import React, { useState, useEffect } from 'react';
import './addContactPerson.scss';
import { ContactSolutation } from '../../../utils/dropsdown';
import InputField from '../../../component/form/FormInput';
import InputSelect from '../../../component/inputSelect/InputSelect';
import Button from '../../../component/ui/Button';
import { useDispatch } from 'react-redux';
import { updateVendorContactPerson, vendor_contact_create } from '../../../store/action/vendor';
import { toast } from 'react-toastify';

const AddContactPerson = ({
	selectedContactPersonIndex,
	tableData,
	setTableData,
	onClose,
	reloadTable,
	vendorId,
}) => {
	const dispatch = useDispatch();
	const [disabled, setDisabled] = useState(false);
	const [error, setError] = useState({});
	const [formData, setFormData] = useState({
		salutation: '',
		first_name: '',
		last_name: '',
		email: '',
		work_phone: '',
		mobile: '',
		department: '',
	});

	useEffect(() => {
		if (selectedContactPersonIndex !== null) {
			const contactPerson = tableData[selectedContactPersonIndex];
			const newFormData = {
				salutation: contactPerson?.salutation || '',
				first_name: contactPerson?.first_name || '',
				last_name: contactPerson?.last_name || '',
				email: contactPerson?.email || '',
				work_phone: contactPerson?.work_phone || '',
				mobile: contactPerson?.mobile || '',
				department: contactPerson?.department || '',
			};
			setFormData(newFormData);
		}
	}, [selectedContactPersonIndex, tableData]);

	const handleInputChange = (key, value) => {
		setFormData((prev) => ({
			...prev,
			[key]: value,
		}));
	};

	const validateEmail = (value) => {
		const regex =
			/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return regex.test(value);
	};

	const checkValidation = () => {
		const errorEmail = { ...error };

		if (
			((!formData.email || formData.email === '' || formData.email === undefined) &&
				(!formData.work_phone || formData.work_phone === '' || formData.work_phone === null)) ||
			(errorEmail.email && formData.email !== '')
		) {
			errorEmail.email = errorEmail.email ?? 'Please enter email address';
		} else {
			delete errorEmail.email;
		}

		if (
			((!formData.work_phone || formData.work_phone === '' || formData.work_phone === null) &&
				(!formData.email || formData.email === '' || formData.email === undefined)) ||
			(errorEmail.work_phone && formData.work_phone !== '')
		) {
			errorEmail.work_phone = errorEmail.work_phone ?? 'Please enter work phone number';
		} else {
			delete errorEmail.work_phone;
		}

		if (Object.keys(errorEmail).length > 0) {
			setError(errorEmail);
			return true;
		} else {
			return false;
		}
	};

	const addContactPerson = () => {
		let isError = checkValidation();
		if (isError) {
			toast.error('Unable to add contact person');
		} else {
			if (vendorId) {
				dispatch(vendor_contact_create(formData, vendorId)).then((res) => {
					if (res?.success) {
						toast.success(res?.message);
						setTableData([...tableData, formData]);
						onClose();
					}
				});
			} else {
				setTableData([...tableData, formData]);
				onClose();
			}
		}
	};

	const updateContactPerson = () => {
		let isError = checkValidation();
		if (isError) {
			toast.error('Unable to add contact person');
		} else {
			if (vendorId) {
				const contactPersonId = tableData[selectedContactPersonIndex]?.contact_person_id;
				dispatch(updateVendorContactPerson(vendorId, contactPersonId, formData))
					.then((res) => {
						if (res?.success) {
							toast.success(res?.message);
						} else {
							toast.error(res?.message || 'Something went wrong');
						}
					})
					.catch((err) => {
						toast.error(err?.message || 'Something went wrong');
					});
			}

			const newTableData = tableData.map((data, i) =>
				i === selectedContactPersonIndex ? { ...data, ...formData } : { ...data },
			);

			setTableData(newTableData);
			onClose();
		}
	};

	const handleKeyDown = (event) => {
		if (event.key === 'Enter') {
			if (selectedContactPersonIndex !== null) {
				updateContactPerson();
			} else {
				addContactPerson();
			}
		}
	};

	return (
		<div
			className="add-contact-person"
			onKeyDown={handleKeyDown}
		>
			<div className="row">
				<div className="col">
					<InputSelect
						options={ContactSolutation || []}
						label="Salutation"
						placeholder="Salutation"
						className="vendorContact-salutation"
						onChange={(value) => handleInputChange('salutation', value)}
						value={formData.salutation}
						disabled={disabled}
						error={error?.salutation}
						autoFocus={true}
					/>
				</div>
				<div className="col">
					<InputField
						label="First Name"
						placeholder="First Name"
						type="text"
						value={formData.first_name}
						onChange={(value) => handleInputChange('first_name', value)}
						disabled={disabled}
						error={error?.first_name}
					/>
				</div>
				<div className="col">
					<InputField
						label="Last Name"
						placeholder="Last Name"
						type="text"
						value={formData.last_name}
						onChange={(value) => handleInputChange('last_name', value)}
						disabled={disabled}
						error={error?.last_name}
					/>
				</div>
			</div>

			<div className="row">
				<div className="col">
					<InputField
						label="Email"
						placeholder="Email"
						type="text"
						value={formData.email}
						onChange={(value) => {
							let errorEmail = { ...error };
							if (value) {
								if (validateEmail(value)) {
									delete errorEmail.email;
									if (
										(formData.work_phone === '' || formData.work_phone === null) &&
										errorEmail.work_phone
									) {
										delete errorEmail.work_phone;
									}
								} else {
									errorEmail.email = 'Please enter a valid email address';
								}
							} else {
								if (formData.work_phone !== '' && errorEmail.work_phone) {
									errorEmail.email = 'Please enter a valid email address';
								} else {
									delete errorEmail.email;
								}
							}
							setError(errorEmail);
							handleInputChange('email', value);
						}}
						disabled={disabled}
						error={error?.email}
					/>
				</div>
				<div className="col">
					<InputField
						label="Phone(Work)"
						placeholder="Phone No."
						type="text"
						value={formData.work_phone}
						onChange={(valueData) => {
							let value = valueData.replace(/[^0-9]/g, '');
							let errorEmail = { ...error };
							if (value) {
								if (value.length < 11) {
									const regex = /^[1-9]\d{9}$/;
									if (regex.test(value)) {
										if (value.length === 10) {
											delete errorEmail.work_phone;
											if ((formData.email === '' || formData.email === null) && errorEmail.email) {
												delete errorEmail.email;
											}
										} else {
											errorEmail.work_phone = 'Please enter a valid Phone(Work)';
										}
									} else {
										errorEmail.work_phone = `Please enter valid Phone(Work) ${value[0] === '0' ? 'and cannot start with 0' : ''}`;
									}
									handleInputChange('work_phone', value);
								}
							} else {
								if (formData.email !== '' && errorEmail.email) {
									errorEmail.work_phone = 'Please enter a valid Phone(Work)';
								} else {
									delete errorEmail.work_phone;
								}
								handleInputChange('work_phone', value);
							}
							setError(errorEmail);
						}}
						disabled={disabled}
						error={error?.work_phone}
					/>
				</div>
			</div>
			<div className="row">
				<div className="col">
					<InputField
						label="Phone(Mobile)"
						placeholder="Phone no."
						type="text"
						value={formData.mobile}
						onChange={(valueData) => {
							let errorEmail = { ...error };

							let value = valueData?.replace(/[^0-9]/g, '');
							if (value) {
								if (value.length < 11) {
									const regex = /^[1-9]\d{9}$/;
									if (regex.test(value)) {
										if (value.length > 10 || value.length < 10) {
											errorEmail.mobile = 'Please enter valid Phone(Mobile)';
											handleInputChange('mobile', value);
											setError(errorEmail);
										} else {
											delete errorEmail.mobile;
											setError(errorEmail);
											handleInputChange('mobile', value);
										}
									} else {
										errorEmail.mobile = `Please enter valid Phone(Mobile) ${value[0] === '0' ? 'and cannot start with 0' : ''}`;
										setError(errorEmail);
										handleInputChange('mobile', value);
									}
								}
							} else {
								delete errorEmail.mobile;
								setError(errorEmail);
								handleInputChange('mobile', value);
							}
						}}
						disabled={disabled}
						error={error?.mobile}
					/>
				</div>
				<div className="col">
					<InputField
						label="Department"
						placeholder="Department"
						type="text"
						value={formData.department}
						onChange={(value) => handleInputChange('department', value)}
						disabled={disabled}
						error={error?.department}
					/>
				</div>
			</div>
			<br />

			<span className="">
				<Button
					type="button"
					className="btn-primary px-5 w-auto"
					button={selectedContactPersonIndex !== null ? 'Save' : 'Add'}
					onClick={() => {
						if (selectedContactPersonIndex !== null) {
							updateContactPerson();
						} else {
							addContactPerson();
						}
					}}
				/>
			</span>
		</div>
	);
};

export default AddContactPerson;
